import React, { useState, useEffect, useContext } from 'react';
import JobNotificationService from "../../Controller/JobNotificationController";
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateJobNotification from './CreateJobNotification';
import { handleSubmit } from "../../Controller/AddJobNotificationController";
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function JobsNotificationPage({ JobID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [JobNotificationList, setJobNotificationData] = useState([]);
    JobID = localStorage.getItem('JobID');
    const { theme } = useContext(ThemeContext);
    const [buttonState, setButtonState] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentJobNotification, setCurrentJobNotification] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");
    const fetchJobNotifications = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setJobNotificationData([]);
            const data = await JobNotificationService.GetAllJobNotifications(redirectCallback, JobID);
            setJobNotificationData(data);
        } catch (error) {
            console.error('Error fetching Job Notifications:', error);
        }
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        const initialState = {};
        JobNotificationList.forEach(job => {
            initialState[job.vc_Email] = job.SendNotification === 1;
        });
        setButtonState(initialState);
    }, [JobNotificationList]);

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobDetail();
        if (JobID > 0) {
            fetchJobNotifications();
        } else {
            setJobNotificationData([]);
        }
    }, [JobID, localStorage.getItem("Closed")]);

    const handleButtonToggle = async (job) => {
        // Determine the new state
        const newState = !buttonState[job.vc_Email]; // Toggle the state

        // Update the button state
        setButtonState(prevState => ({
            ...prevState,
            [job.vc_Email]: newState
        }));

        // Handle the logic based on the new state
        if (newState) {
            await handleSubmit(job); // Perform actions for the "On" state
        } else {
            await JobNotificationService.UnmarkJobNotification(job.PK_Notification_ID); // Perform actions for the "Off" state
        }
        fetchJobNotifications(); // Refresh the list after changes
    };

    const handleCreateJobNotificationClick = () => {
        setCurrentJobNotification(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    const handleEditClick = (job) => {
        // Check if ContactType is "Contact" or "Engineers"
        if (job.ContactType === 'Contact' || job.ContactType === 'Engineers') {
            // Prevent editing for these ContactTypes
            return;
        }
        if (job.PK_Notification_ID > 0) {
            setCurrentJobNotification(job); // Set the notification to be edited
            setIsModalOpen(true);
        }
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event
        const confirmed = window.confirm("Are you sure you want to delete this notification?");
        if (confirmed) {
            try {
                await JobNotificationService.DeleteJobNotifications(ID);
                fetchJobNotifications(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Job Notification:', error);
            }
        }
    };

    const handleSuccess = () => {
        fetchJobNotifications();
        handleCloseModal();   // Close the modal
    };

    const HelpLink = localStorage.getItem('HelpLink');

    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateJobNotificationClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className='divTable'>
                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th></th>
                                    <th style={{ textAlign: "right" }}>Actions</th>
                                </tr>
                            </thead>
                        </table>
                        <div style={{ maxHeight: "460px", overflow: "auto" }}>
                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <tbody>
                                    {JobNotificationList.map((job, index) => (
                                        <tr key={job.PK_Notification_ID} onClick={() => handleEditClick(job)} style={{ cursor: 'pointer' }}>
                                            <td className="no-wrap">{job.vc_Name}</td>
                                            <td className="no-wrap">{job.vc_Email}</td>
                                            <td className="no-wrap">{job.ContactType}</td>
                                            <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ textAlign: "right" }}>
                                                <button style={{ "padding": "4px 6px" }} disabled={isClosed === '1' || isClosed === 1}
                                                    className={`btn ${buttonState[job.vc_Email] !== undefined ? (buttonState[job.vc_Email] ? ' btn-success btn-sm' : 'btn-secondary btn-sm') : (job.SendNotification === 1 ? 'btn-success' : 'btn-secondary')}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent the row click event
                                                        handleButtonToggle(job);
                                                    }}
                                                >
                                                    {buttonState[job.vc_Email] !== undefined ? (buttonState[job.vc_Email] ? 'On' : 'Off') : (job.SendNotification === 1 ? 'On' : 'Off')}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <CreateJobNotification
                    jobNotification={currentJobNotification}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    JobID={JobID}
                />
            )}
        </div>
    );
}

export default JobsNotificationPage;
